import at from '../actionTypes'
import createReducer from './utilities/createReducer'

export default createReducer({}, {
	[at.notificationStatus]: (state, action) => ({
		...state,
		notificationsUnread: action.payload.notificationsUnread
	}),
	[at.notificationsFetch_Success]: (state, action) => ({
		...state,
		notifications: action.payload.notifications
	}),
	[at.notificationsMoreFetch_Success]: (state, action) => ({
		...state,
		notifications: [...state.notifications, ...action.payload.notifications]
	})
})



// WEBPACK FOOTER //
// ./src/redux/reducers/notificationReducer.js